<template>

  <div>
    <div v-for="row in rows" class="merge" :class="row.reportPath ? 'maxMerge' : ''">
      <template v-if="colName==='contractNo'">
        <div >{{ row.contractNo }}</div>
      </template>
      <template v-if="colName==='projectType'">
        <div >{{ row.projectType }}</div>
      </template>
      <template v-if="colName==='salesName'">
        <div > {{ row.salesList ? row.salesList.map(item => item.name).join(';') : '' }}</div>
      </template>
      <template v-if="colName==='customerName'">
        <div> {{
            row.customerList ? Array.from(new Set(row.customerList.map(item => item.realName))).join(';') : ''
          }}
        </div>
      </template>
      <template v-if="colName==='sampleNum'">
        <div v-if="row.sampleNum">{{ row.sampleNum }}</div>
        <div v-else style="color: #5daf34">NA</div>
      </template>
      <template v-if="colName==='sampleInfo'">
        <div v-if="row.sampleNum" style="cursor: pointer;color: #2979cb" @click="lookSampleInfo(row)">查看样本<i
            class="viewIcon" v-html="viewDetailIcon()"></i></div>
        <div v-else style="color: #5daf34">NA</div>
      </template>
      <template v-if="colName==='reportPath'">
        <div v-if="row.reportPath">
          <div style="height: 25px;line-height: 25px;display: flex">
            <span>文件名：</span>
            <span style="color: #5daf34;">
              <span  @click=" downReportFile(row, false)" style="cursor: pointer">
                <span style="border: 1px solid #5daf34;padding:1px 3px;border-radius: 3px;margin-right: 5px">
                  <i class="el-icon-download"
                     style="font-size: 13px;font-weight: bold;"></i>
                  <span>下载</span>
                </span>
              </span>
              <span v-if="row?.reportPath?.fileName">
                {{ row?.reportPath?.fileName?.substring(0,calculateStringLength(row?.reportPath?.fileName, 210).lastIdx)|| '' }}
                <el-tooltip :content="row?.reportPath?.fileName">
                  <span style="cursor: pointer">...</span>
                </el-tooltip>
              </span>
            </span>
          </div>
          <div style="height: 25px;line-height: 25px">文件大小：{{ row?.reportPath?.fileLength || '' }}</div>
        </div>
        <div v-else></div>
      </template>

    </div>
    <!--    样本信息-->
    <sample-info-dialog v-if="sampleInfoDialog"
                        :show-dialog.sync="sampleInfoDialog"
                        :select-detail="selectDetail"></sample-info-dialog>
  </div>
</template>
<script>
import SampleInfoDialog from "@/components/SampleInfoDialog.vue";
import {goodIcon, viewDetailIcon, webIcon1} from "@/utils/iconUtils";
import {downloadReport} from "@/api/naked/rawData/project";
import {calculateStringLength} from "../../../utils/utils";

export default {
  name: "NakedTableSlot",
  components: {SampleInfoDialog},
  props: {
    rows: {
      type: Array,
      default: () => []
    },
    colName: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      columns: [],
      selectDetail:null,
      sampleInfoDialog: false,
      goodIcon: goodIcon,
      webIcon1: webIcon1,
    }
  },
  methods: {
    calculateStringLength,
    viewDetailIcon() {
      return viewDetailIcon
    },
    lookSampleInfo(row) {
      this.selectDetail = {
        projectId: row.id,
        platform: 'LUOCE',
        isNeedFilterSample: row.hasSampleNames,
        sampleNameList: row.sampleNames ? row.sampleNames : []
      }
      this.sampleInfoDialog = true
    },
    downReportFile(row, isOpenSoft) {
      downloadReport(row.id).then(res => {
        if (res?.code === 200) {
          if (isOpenSoft) {
            let url = `linenrawdownload://downloadUrl=` + res.data.replace("delivery.biozeron.com", window.location.hostname)
            //判断本地是否能启动某个命令程序
            window.protocolCheck(url,
                function () {
                  alert(`<div style="text-align: left;color: #5a5e66"><i class="el-icon-warning" style="color: #e4a13d;font-size: 16px;margin-right: 5px" ></i>检测到您未安装原始数据下载器，辛苦您下载安装后再使用软件下载数据。<br>下载地址：<a class="aLink"  href="http://58.247.16.28:63306/prod-api/client/downloader">http://58.247.16.28:63306/prod-api/client/downloader</a></div>`)
                })
          } else {
            const url = res.data.replace("delivery.biozeron.com", window.location.hostname)
            const elink = document.createElement('a')
            elink.href = url
            document.body.appendChild(elink)
            elink.click()
            document.body.removeChild(elink)
          }
        }
      })
    },
  },
}
</script>
<style scoped>

.merge:not(:last-child) {
  border-bottom: 1px solid #e8e8e8;
}
.merge div {
 padding:0px 15px;
  line-height: 40px;
  height: 40px;
  box-sizing: border-box;
  //display:inline-block
}
.maxMerge div{
  line-height: 63px;
  height: 63px;
  padding-bottom: 5px;
  padding-top: 5px;
}

/deep/ .el-dropdown{
  padding: 0px!important;
}
</style>
